/* EMBERCORE theme scripts — vanilla, no dependencies */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    var btn = root.querySelector('[data-lb-burger]');
    var nav = root.querySelector('[data-lb-mnav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-lb-gallery]').forEach(function (gal) {
      var slides = gal.querySelectorAll('[data-lb-slide]');
      var thumbs = gal.querySelectorAll('[data-lb-thumb]');
      if (!slides.length) return;
      function show(i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () { show(n); });
      });
      // swipe
      var x0 = null, cur = 0;
      var main = gal.querySelector('[data-lb-gal-main]');
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 44) {
            cur = (cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
            show(cur);
          }
          x0 = null;
        }, { passive: true });
      }
    });
  }

  /* ---------- Offer / bundle selector ---------- */
  function initOffers(root) {
    root.querySelectorAll('[data-lb-offers]').forEach(function (box) {
      var offers = box.querySelectorAll('[data-lb-offer]');
      var form = document.getElementById('lb-product-form');
      var idInput = form ? form.querySelector('[data-lb-variant-id]') : null;
      var qtyInput = form ? form.querySelector('[data-lb-qty]') : null;
      var priceNow = document.querySelector('[data-lb-price-now]');
      var priceWas = document.querySelector('[data-lb-price-was]');
      var priceSave = document.querySelector('[data-lb-price-save]');
      var stickPrice = document.querySelector('[data-lb-stick-price]');

      function pick(el) {
        offers.forEach(function (o) {
          var on = o === el;
          o.classList.toggle('is-on', on);
          var inp = o.querySelector('input');
          if (inp) inp.checked = on;
        });
        var d = el.dataset;
        if (idInput && d.variantId) idInput.value = d.variantId;
        if (qtyInput && d.qty) qtyInput.value = d.qty;
        if (priceNow && d.price) priceNow.textContent = d.price;
        if (priceWas) {
          priceWas.textContent = d.compare || '';
          priceWas.style.display = d.compare ? '' : 'none';
        }
        if (priceSave) {
          priceSave.textContent = d.save || '';
          priceSave.style.display = d.save ? '' : 'none';
        }
        if (stickPrice && d.price) {
          stickPrice.innerHTML = (d.compare ? '<s>' + d.compare + '</s>' : '') + d.price;
        }
      }

      offers.forEach(function (o) {
        o.addEventListener('click', function () { pick(o); });
        o.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(o); }
        });
      });
      var initial = box.querySelector('[data-lb-offer].is-on') || offers[0];
      if (initial) pick(initial);
    });
  }

  /* ---------- Controller (signature widget) ---------- */
  var MODE_KEYS = ['tap', 'tap', 'press', 'press', 'knead', 'knead', 'wave', 'wave'];

  function initController(root) {
    root.querySelectorAll('[data-lb-ctrl]').forEach(function (ctrl) {
      var belt = ctrl.querySelector('[data-lb-belt]');
      var heatVal = ctrl.querySelector('[data-lb-heat-val]');
      var modeVal = ctrl.querySelector('[data-lb-mode-val]');
      var tempVal = ctrl.querySelector('[data-lb-temp-val]');
      var modeName = ctrl.querySelector('[data-lb-mode-name]');
      var labels = {};
      try { labels = JSON.parse(ctrl.dataset.lbLabels || '{}'); } catch (e) { labels = {}; }
      var temps = (ctrl.dataset.lbTemps || '38,42,46,50,54,58').split(',');

      function paint(heat, mode) {
        if (belt) {
          belt.style.setProperty('--lb-heat', heat);
          belt.style.setProperty('--lb-speed', (0.6 + mode * 0.16).toFixed(2));
          belt.classList.toggle('is-vibe', mode > 0);
        }
        if (heatVal) heatVal.firstChild.nodeValue = heat ? String(heat).padStart(2, '0') : '--';
        if (modeVal) modeVal.firstChild.nodeValue = mode ? String(mode).padStart(2, '0') : '--';
        if (tempVal) tempVal.firstChild.nodeValue = heat ? (temps[heat - 1] || '--') : '--';
        if (modeName) modeName.textContent = mode ? (labels[MODE_KEYS[mode - 1]] || '') : (labels.off || 'Off');
      }

      var heat = 3, mode = 5;

      ctrl.querySelectorAll('[data-lb-heat]').forEach(function (b) {
        b.addEventListener('click', function () {
          heat = parseInt(b.dataset.lbHeat, 10);
          ctrl.querySelectorAll('[data-lb-heat]').forEach(function (x) {
            x.classList.toggle('is-on', x === b);
          });
          paint(heat, mode);
        });
      });
      ctrl.querySelectorAll('[data-lb-mode]').forEach(function (b) {
        b.addEventListener('click', function () {
          mode = parseInt(b.dataset.lbMode, 10);
          ctrl.querySelectorAll('[data-lb-mode]').forEach(function (x) {
            x.classList.toggle('is-on', x === b);
          });
          paint(heat, mode);
        });
      });
      paint(heat, mode);
    });
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-lb-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-lb-atc-anchor]');
    if (!anchor) { return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(anchor);
    }
    var btn = bar.querySelector('[data-lb-stick-btn]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        var form = document.getElementById('lb-product-form');
        if (form) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); }
      });
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-lb-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    els.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .55s ease, transform .55s ease';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'none';
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot(root) {
    root = root || document;
    initMenu(root);
    initGallery(root);
    initOffers(root);
    initController(root);
    initSticky(root);
    initReveal(root);
  }

  ready(function () { boot(document); });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
